import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { ModuloEnteDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ModuloEnteApiClient extends BaseCRUDApiClient<ModuloEnteDto> {
  baseUrl = this.config.apiEndpoint + '/modulo-ente';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
